import { useEffect } from 'react';
import { useFetcher } from '@remix-run/react';
import SwiperCore from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import RecentlyViewedDesktop from './RecentlyViewed.desktop';
import RecentlyViewedMobile from './RecentlyViewed.mobile';
import {
    HREF_RECENTLY_VIEWED_ARTICLES,
    type loader,
} from '~/routes/remix-api.articles.get-recently-viewed-articles';
import { fetcherIsInit } from '~/utils/fetcherHelper';

SwiperCore.use([Navigation, Pagination]);

const RecentlyViewed: React.FC = () => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const fetcher = useFetcher<typeof loader>();
    const recentlyViewed = fetcher.data?.recentlyViewedArticles ?? [];

    useEffect(() => {
        if (fetcherIsInit(fetcher)) {
            fetcher.load(HREF_RECENTLY_VIEWED_ARTICLES);
        }
    }, [fetcher]);

    if (!recentlyViewed?.length) return null;

    return (
        <>
            {isMobile ? (
                <RecentlyViewedMobile recentlyViewed={recentlyViewed} />
            ) : (
                <RecentlyViewedDesktop recentlyViewed={recentlyViewed} />
            )}
        </>
    );
};

export default RecentlyViewed;
